import createVueApp from '@phoenix/createVueApp';
import CountryProposition from '@maison/components/dispatch/CountryProposition.vue';

const app = createVueApp({}, true);
app.component('CountryProposition', CountryProposition);
app.mount('#phoenix-country-proposition-banner');
